import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';

export const BTTextFieldProps = {
    '&.MuiTextField-root': {
        '.MuiInputLabel-root': {
            opacity: 0.5,
            top: '3px',
            color: 'var(--color-primary)',

            '&.Mui-focused': {
                color: 'inherit'
            }
        },
        '.MuiFormHelperText-root': {
            color: 'var(--tasks-text-secondary)',
        },
        '.MuiInput-root': {
            '&.Mui-disabled': {
                color: 'var(--tasks-text-secondary)',
            },
            '&:before': {
                borderColor: '210 40% 96.1%',
            },
            '&:hover:not(.Mui-disabled):before': {
                borderColor: '210 40% 96.1%',
            }
        },
        '.MuiInputBase-input': {
            color: 'var(--color-primary)',

            '&.Mui-disabled': {
                color: 'var(--tasks-text-secondary)',
                WebkitTextFillColor: 'var(--tasks-text-secondary)',
            }
        },
        '.MuiInputAdornment-root': {
            '& .MuiButtonBase-root': {
                color: 'var(--color-primary)',
            }
        },
        '.MuiOutlinedInput-notchedOutline': {
            borderColor: '210 40% 96.1%',
        }
    },
};

export const BTTextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
    (props, ref) => {
      return (
        <TextField
          {...props}
          inputRef={ref}
          variant={props.variant ?? 'standard'}
        />
      );
    }
);

export default BTTextField;

